import { AbstractCommand } from 'src/models/command';

class LinkTheAggregateToTheIdo extends AbstractCommand {
	readonly name = 'IFS_IDO_Command_Command_LinkTheAggregateToTheIdo';

	public constructor(aggregateId: string, idoId: number, idoInstanceId: number) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			idoId: idoId,
			idoInstanceId: idoInstanceId,
		};
	}
}

export { LinkTheAggregateToTheIdo };
